module.exports = __webpack_public_path__ + "media/images/pages/img_cover_left_02-1846c47bbf7ef513f61a5fff966d12d6.jpg";